export function detectIos() {
  const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
  return Boolean(userAgent.match(/iPhone|iPad|iPod/i));
}

export function detectMobile() {
  const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
  return Boolean(
    userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
  );
}

export function detectDesktopLayout() {
  const isMobile = detectMobile();
  return (isMobile && window.innerWidth >= 1024) || (!isMobile && window.innerWidth >= 768);
}
